module.exports = __webpack_public_path__ + "img/ema.b4640ca4.jpg";